/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Gotowość sukcesyjna wynikająca ze ścieżek kariery pracownika. READY — gotowy teraz. IN_PREPARATION — wskazany jako następca, ale z odleglejszym horyzontem. NONE — nie jest następcą na żadnym stanowisku. 
 * @export
 * @enum {string}
 */

export const TeamEmployeeSuccessionStatusDto = {
    Ready: 'READY',
    InPreparation: 'IN_PREPARATION',
    None: 'NONE'
} as const;

export type TeamEmployeeSuccessionStatusDto = typeof TeamEmployeeSuccessionStatusDto[keyof typeof TeamEmployeeSuccessionStatusDto];



